import { render } from "./Datenschutz.vue?vue&type=template&id=b610adee"
const script = {}

import "./Datenschutz.vue?vue&type=style&index=0&id=b610adee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__